import React, { useState, useEffect } from 'react';
import { Chart } from "react-google-charts";
import { Link } from 'react-router-dom'

function AlertProfitChart(props) {

    const [performance, setPerformance] = useState({})
    const [showUnrealized, setShowUnrealized] = useState(false);
    const [quoteHistory, setQuoteHistory] = useState(null);

    useEffect(() => {
        (async function () {
            if (props.performance)
                setPerformance(props.performance);

            if (showUnrealized && props.symbol && props.performance && props.performance.trades && props.performance.trades.length) {

                const url = `/api/quoteHistory?symbol=` + props.symbol +
                    "&startDate=" + new Date(props.startDate).toLocaleDateString() +
                    "&endDate=" + new Date(props.endDate).toLocaleDateString();
                let history = await (await fetch(url)).json();
                history.reverse();
                setQuoteHistory(history);
            }
        })();
    }, [props.alertId, props.performance, showUnrealized, props.symbol, props.startDate, props.endDate]);

    function getUnrealizedProfitChartData() {
        if (performance && performance.trades && performance.trades.length && quoteHistory && quoteHistory.length) {
            let ret = [];
            ret.push(["Date", "Net Profit"]);
            let min = null;
            let max = null;
            let totalValue = 100000.0;
            quoteHistory.forEach(q => {
                let date = new Date(q.date);
                let dateString = (date.getUTCMonth() + 1) + "/" + date.getUTCDate() + "/" + (date.getUTCFullYear() - 2000);
                let inTrade = performance.trades.find(t => {
                    let purchaseDate = new Date(t.purchaseDate);
                    let sellDate = t.sellDate ? new Date(t.sellDate) : null;
                    return date > purchaseDate && (t.sellDate === null || date <= sellDate);
                });
                if (inTrade) {
                    let change = q.change_percent * (props.isShort ? -1 : 1);
                    totalValue *= (1 + change)
                }
                let netProfit = (totalValue - 100000) / 100000;
                if (max === null || netProfit > max) max = netProfit;
                if (min === null || netProfit < min) min = netProfit;

                ret.push([dateString, netProfit])

            });
            return [ret, min, max];
        } else {
            return null;
        }
    }

    function getRealizedProfitChartData() {
        if (performance && performance.trades && performance.trades.length) {
            let ret = [];
            if (props.showDrawdown)
                ret.push(["Date", "Realized Drawdown"])
            else
                ret.push(["Date", "Realized Profit"])
            let net = 0.0;
            let min = null;
            let max = null;
            let maxProfit = null;
            let totalValue = 100000.0; // Assuming initial investment is 100,000
            performance.trades.forEach(t => {
                if (t.sellDate) {
                    totalValue *= (1 + t.profitPercentage / 100);
                    let netProfit = (totalValue - 100000.0) / 100000 * 100; // Assuming initial investment is 100,000
                    if (maxProfit === null || netProfit > maxProfit)
                        maxProfit = netProfit;
                    if (props.showDrawdown) {
                        net = maxProfit - netProfit;
                    } else {
                        net = netProfit;
                    }
                    let sellDate = new Date(t.sellDate);
                    let date = (sellDate.getUTCMonth() + 1) + "/" + sellDate.getUTCDate() + "/" + (sellDate.getUTCFullYear() - 2000);
                    ret.push([date, net / 100])
                    if (max === null || net > max) max = net;
                    if (min === null || net < min) min = net;
                }
            })
            return [ret, min / 100, max / 100];
        } else {
            return null;
        }
    }

    let chartData = showUnrealized ? getUnrealizedProfitChartData() : getRealizedProfitChartData();
    console.log(chartData);
    let chartOptions = chartData ? {
        legend: { position: 'none' },
        vAxis: {
            format: '#%',
            viewWindow: {
                max: chartData[2],
                min: props.showDrawdown ? 0 : chartData[1]
            }
        }
    } : null;

    return (
        <div>
            {
                props.performance && props.performance.trades && props.performance.trades.length && chartData ?
                    <Chart
                        chartType="AreaChart"
                        width={"100%"}
                        data={chartData[0]}
                        options={chartOptions}
                        chartPackages={["corechart", "controls"]}
                    />
                    :
                    null
            }
            <center><Link onClick={() => setShowUnrealized(!showUnrealized)}>{showUnrealized ? "Show Realized" : "Show Unrealized"}</Link></center>
        </div >);
}

export default AlertProfitChart;